import { StyleSheet } from 'react-native';
import { colors, spacings } from '@views/shared/styles';

const { grey1, blackAlpha } = colors;
const {
  big,
  extraSmall,
  medium,
  oversize,
  small,
  verySmall,
  smallMedium,
} = spacings;

export const styles = StyleSheet.create({
  left: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: medium,
    flex: 1,
  },
  pageHeader: {
    backgroundColor: grey1,
    marginBottom: oversize,
    borderRadius: extraSmall,
    padding: big,
    alignItems: 'center',
  },
  container: {
    marginBottom: medium,
  },
  title: {
    paddingLeft: small,
  },
  itemContainer: {
    paddingVertical: small,
    paddingLeft: medium,
    borderColor: blackAlpha,
    borderTopWidth: 1,
    paddingRight: smallMedium,
  },
  item: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  building: {
    borderColor: blackAlpha,
    borderTopWidth: 1,

    flexDirection: 'row',
    backgroundColor: 'none',
    paddingVertical: verySmall,
    paddingRight: smallMedium,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flex: 1,
    alignItems: 'center',
    paddingRight: small,
  },
  badge: {
    justifyContent: 'center',
    paddingRight: medium,
  },
  openStyle: {
    borderBottomColor: blackAlpha,
    borderBottomWidth: 1,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  accordionChildren: {
    marginBottom: medium,
    marginTop: small,
  },
  accordionHeader: {
    backgroundColor: grey1,
  },
  accordionChildrenBuilding: {
    margin: 0,
    paddingHorizontal: medium,
  },
  flexContainer: {
    flex: 1,
  },
});
